import { useNavigate } from 'react-router-dom';
import { useAppStore } from '@/store/AppStore';
import { jobRemaining } from '@/lib/finance';

interface AttentionItem {
  key: string;
  label: string;
  value: number;
  path: string;
  icon: string;
  tone: string;
}

export default function AttentionCenter() {
  const { requests, quotes, jobs, payments, appointments } = useAppStore();
  const navigate = useNavigate();

  const videoWaiting = requests.filter((r) => r.videoStatus === 'Video Bekleniyor').length;
  const videoNoQuote = requests.filter(
    (r) => r.videoStatus === 'Video Geldi' && ['Video Geldi', 'Değerlendiriliyor', 'Teklif Hazırlanacak'].includes(r.status),
  ).length;
  const quoteWaitingReply = quotes.filter((q) => q.status === 'Cevap Bekleniyor').length;
  const approvedNoAppointment = quotes.filter(
    (q) => q.status === 'Onaylandı' && !appointments.some((a) => a.quoteId === q.id),
  ).length;
  const todaysAppointmentNoTeam = appointments.filter((a) => a.date === '26 Ağustos 2026' && !a.team).length;
  const completedWithBalance = jobs.filter((j) => j.status === 'Kapandı' && jobRemaining(j, payments) > 0).length;

  const items: AttentionItem[] = [
    { key: 'video', label: 'müşteriden video bekleniyor', value: videoWaiting, path: '/teklif-talepleri', icon: 'ri-video-line', tone: 'bg-amber-50 text-amber-600' },
    { key: 'quote', label: 'video geldi fakat teklif hazırlanmadı', value: videoNoQuote, path: '/teklif-talepleri', icon: 'ri-file-add-line', tone: 'bg-red-50 text-red-600' },
    { key: 'reply', label: 'teklif müşteri cevabı bekliyor', value: quoteWaitingReply, path: '/teklifler', icon: 'ri-chat-3-line', tone: 'bg-amber-50 text-amber-600' },
    { key: 'approved', label: 'onaylı teklif randevuya bağlanmadı', value: approvedNoAppointment, path: '/teklifler', icon: 'ri-calendar-event-line', tone: 'bg-red-50 text-red-600' },
    { key: 'team', label: 'bugünkü randevuya ekip atanmadı', value: todaysAppointmentNoTeam, path: '/randevu', icon: 'ri-group-line', tone: 'bg-red-50 text-red-600' },
    { key: 'balance', label: 'tamamlanan işte bakiye bulunuyor', value: completedWithBalance, path: '/tahsilatlar', icon: 'ri-wallet-3-line', tone: 'bg-red-50 text-red-600' },
  ].filter((i) => i.value > 0);

  if (items.length === 0) return null;

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-white">
      <div className="flex items-center justify-between border-b border-background-100 px-5 py-4">
        <div className="flex items-center gap-2">
          <span className="h-2 w-2 rounded-full bg-red-500" />
          <h2 className="font-heading text-[15px] font-bold text-foreground-950">Dikkat Gerektiren</h2>
        </div>
        <span className="text-xs font-semibold text-foreground-400">{items.length} konu</span>
      </div>
      <ul className="divide-y divide-background-100">
        {items.map((item) => (
          <li key={item.key}>
            <button
              type="button"
              onClick={() => navigate(item.path)}
              className="flex w-full items-center gap-4 px-5 py-3.5 text-left transition-colors hover:bg-background-50"
            >
              <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${item.tone}`}>
                <i className={`${item.icon} text-lg`} />
              </span>
              <span className="flex-1 text-sm text-foreground-700">
                <span className="font-heading text-base font-bold text-foreground-950">{item.value}</span>{' '}
                {item.label}
              </span>
              <i className="ri-arrow-right-s-line text-foreground-300" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}